import { HttpErrorResponse } from '@angular/common/http';

/** The error body of a request this tab could not get a token for, for a reason other than sign-in. */
export const TOKEN_ACQUISITION_FAILED = 'Token acquisition failed';
/** The error body of a request whose token the ended session could not renew. */
export const SESSION_ENDED = 'Session ended';

/** A request the session could not sign: a 401, or a token the ended session could not renew. */
export function isSignInFailure(err: unknown): boolean {
  return err instanceof HttpErrorResponse && (err.status === 401 || err.error === SESSION_ENDED);
}
